import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/baski/page.tsx");
